import { render } from "./sitemap.md?vue&type=template&id=4e15a6ea"
import script from "./sitemap.md?vue&type=script&lang=js"
export * from "./sitemap.md?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__